/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Priority_Speaker_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to be more easily heard in voice channels. When activated, the volume of others without this permission will be automatically lowered. Priorit..." |
*
* @param {Leveling_Perm_Priority_Speaker_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_priority_speaker_hint = /** @type {((inputs?: Leveling_Perm_Priority_Speaker_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Priority_Speaker_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам быть лучше слышными в голосовых каналах: громкость остальных, у кого нет этого права, автоматически снижается. Режим включается сочетанием клавиш «Режим рации (приоритет)».")
	return /** @type {LocalizedString} */ ("Allows members to be more easily heard in voice channels. When activated, the volume of others without this permission will be automatically lowered. Priority Speaker is activated by using the Push-to-talk (Priority) keybind.")
});